var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M948.69,500.69l-119.9-119.9v-171c0-8.84-7.16-16-16-16h-171L523.31,75.31c-6.25-6.25-16.38-6.25-22.63,0 L382.22,193.78h-171c-8.84,0-16,7.16-16,16v171l-119.9,119.9c-6.25,6.25-6.25,16.38,0,22.63l119.9,119.9v168.13 c0,8.84,7.16,16,16,16h168.13l121.34,121.34c6.25,6.25,16.38,6.25,22.63,0l121.34-121.34h168.13c8.84,0,16-7.16,16-16V643.22 l119.9-119.9C954.93,517.07,954.93,506.93,948.69,500.69z M512,766.01c-140.29,0-254.01-113.73-254.01-254.01 S371.71,257.99,512,257.99S766.01,371.71,766.01,512S652.29,766.01,512,766.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "currentColor"
    },
    cx: 512,
    cy: 512,
    r: 200.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.05dc3306e8dc1345e126fb0372260ccf.svg";
export { ForwardRef as ReactComponent };